import { render, staticRenderFns } from "./receivables.vue?vue&type=template&id=7f8fd932&scoped=true"
import script from "./receivables.vue?vue&type=script&lang=js"
export * from "./receivables.vue?vue&type=script&lang=js"
import style0 from "./receivables.vue?vue&type=style&index=0&id=7f8fd932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8fd932",
  null
  
)

export default component.exports